import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useAuth } from "../contexts/AuthContext";
import CreateEventModal from "./CompanyEvents/CreateEventModal";
import EventsList from "./CompanyEvents/EventsList";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const DashboardStyle = styled.div`
  margin-left: 280px;
  overflow-x: hidden;
`;

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const CardHeader = styled.h4`
  font-weight: bold;
  margin: 0;
`;

const AddEventButton = styled(Button)`
  background-color: #3c2f61;
  color: white;
  border: none;
  
  &:hover {
    background-color: #5a4689 !important;
    color: white !important;
  }
`;

const CompanyEvents = () => {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [createModalVisible, setCreateModalVisible] = useState(false);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_URL}/companies/events/list`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setEvents(response.data.data || []);
    } catch (error) {
      console.error("Error fetching events:", error);
      // message.error("Failed to fetch events. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleEventCreated = () => {
    message.success("Event created successfully!");
    setCreateModalVisible(false);
    fetchEvents();
  };

  return (
    <DashboardStyle>
      <div className="content-container" style={{ marginLeft: "30px", padding: "20px" }}>
        <br /> <br />
        <div className="card">
          <div className="card-body">
            <PageHeader>
              <CardHeader>Company Events</CardHeader>
              <AddEventButton
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setCreateModalVisible(true)}
              >
                Add Event
              </AddEventButton>
            </PageHeader>

            <EventsList
              events={events}
              loading={loading}
              onRefresh={fetchEvents}
            />
          </div>
        </div>
      </div>

      <CreateEventModal
        visible={createModalVisible}
        onCancel={() => setCreateModalVisible(false)}
        onSuccess={handleEventCreated}
      />
    </DashboardStyle>
  );
};

export default CompanyEvents;